import apiSlice from '..';

type Fee = {
  id: number;
  min_amount: number;
  max_amount: number;
  fee: number;
  auction_type: string;
  created_at: string;
  updated_at: string;
};

export const buyerFeesApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getBuyerFees: builder.query<Fee[], string>({
      providesTags: ['BuyerFees'],
      query: auctionType => ({
        url: `/financials/buyer-fees`,
        method: 'GET',
        params: {
          auctionType
        }
      }),
      transformResponse: (response: any) => response.data
    }),
    updateBuyerFees: builder.mutation<Fee[], { fees: Fee[]; auctionType: string }>({
      query: ({ fees, auctionType }) => ({
        url: `/financials/buyer-fees`,
        method: 'POST',
        body: { fees, auctionType }
      }),
      invalidatesTags: ['BuyerFees']
    })
  }),
  overrideExisting: true
});

export const { useGetBuyerFeesQuery, useUpdateBuyerFeesMutation } = buyerFeesApi;
export default buyerFeesApi;
